/* globals localStorage */
export default {
  updateTokens (accessToken, refreshToken) {
    localStorage.token = accessToken
    localStorage.refresh_token = refreshToken
  },
  getToken () {
    return localStorage.token
  },
  logout (cb) {
    delete localStorage.token
    window.location = window.CONFIG.authHost + '/logout.do?redirect=' + window.CONFIG.host
  },

  loggedIn () {
    return !!localStorage.token
  },
  onChange () {}
}



// WEBPACK FOOTER //
// ./src/auth.js